import { render, staticRenderFns } from "./CabecalhoDeDetalhesDoIrmao.vue?vue&type=template&id=21f838fa"
import script from "./CabecalhoDeDetalhesDoIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./CabecalhoDeDetalhesDoIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports